module.exports = __webpack_public_path__ + "static/img/lqm_big.38aa11f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutus/lqm_big.jpg
// module id = TPil
// module chunks = 18